import { createTheme } from '../theme/create-theme';
import type { Direction, Theme } from '../theme/types';

interface ApalThemeConfig {
  direction?: Direction;
}

/**
 * Creates an APAL-branded MUI theme with blue primary color.
 *
 * @example
 * ```tsx
 * import { createApalTheme } from '@apal/shared-theme';
 *
 * const theme = createApalTheme();
 *
 * <ThemeProvider theme={theme}>
 *   <App />
 * </ThemeProvider>
 * ```
 */
export function createApalTheme(config: ApalThemeConfig = {}): Theme {
  return createTheme({
    primaryColor: 'apalBlue',
    direction: config.direction,
  });
}
